import { fromJS } from 'immutable';
import { availableWorkflows } from 'constants/workflows';
import { onboardingProcessSteps } from 'constants/workflowProcessSteps';

export const routeCodes = {
  INDEX: '/',
  DASHBOARD: '/dashboard',
  DESIGNS: '/designs',
  DESIGNER: '/designer',
  RECIPES: '/recipes',
  MENU_ENGINEERING: '/menu-engineering',
  ONBOARDING: '/onboarding',
  LOGIN: '/login',
  REGISTER: '/register',
  LOGIN_FAILED: '/loginFailed',
  RESET_PASSWORD: '/reset-password',
  ABOUT: '/about',
  PLAYGROUND: '/playground',
  MANAGE_ACCOUNT: '/manage-account',
  INGREDIENTS: '/ingredients',
  ADMIN: '/admin',
  VALIDATE_LEGAL: '/validate-legal',
};

export const subRouteCodes = {
  MENU_ENGINEERING: {
    MANAGE_MENU: '/manage',
    MENU_ANALYSIS: '/analysis',
  },
  RECIPES: {
    MANAGE_RECIPE: '/manage',
  },
  MANAGE_ACCOUNT: {
    BRAND: '/brand',
    LOCATION: '/location',
    USER_PROFILE: '/user-profile',
    ASSET_TRANSFER: '/asset-transfer',
  },
  DESIGNS: {
    MANAGE_DESIGN: '/manage',
    CREATE_FROM_THEME: '/create-from-theme',
  },
  INGREDIENTS: {
    BATCH_MANAGE_RECIPE: '/batch',
  },
  ADMIN:{
    ADMIN_LOGIN: '/login',
    ADMIN_HOME: '/home',
  },
};

export const routeParams = {
  MANAGE_DESIGN: {
    TYPE_SIZE: 'type-size',
    BACKGROUND: 'background',
    CONTENT: 'content',
  },
};

export const workflowsRoutes = fromJS({
  [availableWorkflows.ONBOARDING]: {
    baseRoute: routeCodes.ONBOARDING,
    [onboardingProcessSteps.WELCOME]: '/welcome',
    [onboardingProcessSteps.BRAND]: '/brand',
    [onboardingProcessSteps.LOCATION]: '/location',
  },
});
